// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ro-z","breadcrumbForward":"So-z","breadcrumbBack":"To-z","selected":"Uo-z"};